import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';

export default class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLink: 0,
      wrapperStyle: {
        transform: "translate3d(0, 0, 0)",
        width: "1000px"
      },
      slideStyle: {}
    };
    this.numSlides = props.gallery.length;
  }

  display = () => {
    return (
      this.props.gallery.map((item, index) => {
      return (
        <div className="slide" style={ this.state.slideStyle } key={ index }>
          <div className="captions">
            <h2>{ item.issue }</h2>
          </div>
          <img className="before-image" src={ item.beforeImage.url } />
          <img className="after-image" src={ item.afterImage.url } />
        </div>
      );
    }))
  }

  componentDidMount() {
    this.updateWidth();
    // To support server-side rendering
    if (!window) {
      return
    }
    if (window.addEventListener) {
      window.addEventListener('resize', this.updateWidth);
    } else {
      window.attachEvent('onresize', this.updateWidth);
    }
  }

  componentWillUnmount() {
    if (window.addEventListener) {
      window.removeEventListener('resize', this.updateWidth);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }
  }

  render() {
    return (
      <div id="carousel-wrapper">
        <h1 className="meta-info header">Before and Afters</h1>
        <button type="button" onClick={ () => { this.navigate(-1) }} className="previous">◀</button>
        <button type="button" onClick={ () => { this.navigate(1) }} className="next">▶</button>
        <div ref={ this.viewportRefHandler } id="viewport">
          <div ref={ this.slidesRefHandler } id="slides-wrapper" style={ this.state.wrapperStyle }>
            { this.display() }
          </div>
        </div>
      </div>
    )
  }

  viewportRefHandler = (elem) => { this.viewport = elem }
  slidesRefHandler = (elem) => { this.wrapper = elem }

  navigate = (direction) => {
      let newLink = this.state.activeLink + direction;
      if (direction === -1 && newLink < 0) {
        return this.setState({ activeLink: this.numSlides - 1 }, this.updatePosition );
      }
      if (direction === 1 && !this.props.gallery[newLink]) {
        return this.setState({ activeLink: 0 }, this.updatePosition );
      }
      return this.setState({ activeLink: newLink }, this.updatePosition);
  }

  updateWidth = () => {
    const viewportWidth = this.getWidth(this.viewport);
    let newWrapperStyle = Object.assign({}, this.state.wrapperStyle, { width: `${viewportWidth * this.numSlides}px`});
    let newSlideStyle = Object.assign({}, this.state.slideStyle, { width: `${viewportWidth}px`});
    this.setState({
      wrapperStyle: newWrapperStyle,
      slideStyle: newSlideStyle
    });
  }
  updatePosition = () => {
    this.changePosition(this.state.activeLink)
  }

  changePosition = (id) => {
    const viewportWidth = this.getWidth(this.viewport);
    let pos = id * -viewportWidth;
    let translateValue = "translate3d(" + pos + "px, 0, 0)";
    let newWrapperStyle = Object.assign({}, this.state.wrapperStyle, { transform: translateValue });
    this.setState({ wrapperStyle: newWrapperStyle });
  }

  getWidth = (elem) => {
    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
  }
}

Carousel.defaultProps = {
  gallery: []
};



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Carousel.jsx
 **/